import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Accordion from '@cimpress/react-components/lib/Accordion';
import Button from '@cimpress/react-components/lib/Button';
import Spinner from '@cimpress/react-components/lib/shapes/Spinner';
import Tooltip from '@cimpress/react-components/lib/Tooltip';
import { withWizard } from '@cimpress-technology/ff-react-components/lib/Wizard';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { css, cx } from 'react-emotion';
import memoizeOne from 'memoize-one';
import StepTitle from '../common/StepTitle';
import TermLink from '../common/TermLink';
import WizardNavigator from '../common/WizardNavigator';
import { resetState, SUCCESS, FAILURE } from '../../reducers/termselect/actions';

const resultsStyle = css({
  display: 'flex',
  justifyContent: 'space-around'
});

const termStyle = css({
  padding: '10px 0px'
});

const updateContainerStyle = css({
  padding: '20px 50px'
});

const getSuccessfulUpdates = memoizeOne(updates => updates.filter(update => update.status === SUCCESS));

const getFailedUpdates = memoizeOne(updates => updates.filter(update => update.status === FAILURE));

class UpdateStep extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    updateStatusList: PropTypes.arrayOf(
      PropTypes.shape({
        term: PropTypes.objectOf(PropTypes.any).isRequired,
        status: PropTypes.string.isRequired,
        details: PropTypes.string
      })
    ).isRequired
  };

  onPrev = () => {
    const { wizard } = this.props;
    wizard.setStep(wizard.previous);
  };

  onClose = () => {
    const { resetState } = this.props;
    // wipe out selected contracts and selected skus
    resetState();
  };

  render() {
    const { loading, updateStatusList } = this.props;
    const successfulUpdates = getSuccessfulUpdates(updateStatusList);
    const failedUpdates = getFailedUpdates(updateStatusList);
    return loading ? (
      <Spinner />
    ) : (
      <div>
        <StepTitle
          icon="t-shirt-l"
          title="Review your updated contracts"
          description="Your completed contract updates are available below."
        />
        <div className={cx(resultsStyle, 'card')}>
          {successfulUpdates && successfulUpdates.length ? (
            <Accordion title="Updated Contracts">
              <div className={updateContainerStyle}>
                {successfulUpdates.map(termStatus => (
                  <TermLink
                    key={termStatus && termStatus.term && termStatus.term.termId}
                    term={termStatus && termStatus.term}
                    className={termStyle}
                  />
                ))}
              </div>
            </Accordion>
          ) : null}
          {failedUpdates && failedUpdates.length ? (
            <Accordion title="Failed Updates">
              <div className={updateContainerStyle}>
                {failedUpdates.map(termStatus => (
                  <div key={termStatus && termStatus.term && termStatus.term.termId}>
                    <Tooltip direction="left" contents={termStatus.details}>
                      <TermLink
                        key={termStatus && termStatus.term && termStatus.term.termId}
                        term={termStatus && termStatus.term}
                        className={termStyle}
                      />
                    </Tooltip>
                  </div>
                ))}
              </div>
            </Accordion>
          ) : null}
        </div>
        <WizardNavigator
          onPrev={this.onPrev}
          onNext={this.onClose}
          customNext={
            <Link to="/">
              <Button type="primary" onClick={this.onClose}>
                Home
              </Button>
            </Link>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  updateStatusList: state.termSelectReducer.updateStatusList
});

const mapDispatchToProps = dispatch => ({
  resetState: () => dispatch(resetState())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withWizard(UpdateStep));
